module.exports = __webpack_public_path__ + "assets/img/30bc45fa564e06da585dbb71754f043c.webp";